/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 计算淮安文化卡金额
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  createOrder: order.CreateOrder,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: number;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/calculated/amount`,
    data: createOrder,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
